import React from 'react';
import { Col, Row } from 'reactstrap';
import { TypedMemo } from '../../common/types';
import { useCanFilterGeographically } from '../hooks/useCanFilterGeographically';
import { useTopCountries } from '../markets/hooks/useTopCountries';
import { TopMarketsCard } from '../markets/TopMarketsCard';

interface WatchlistMarketsRowProps {
  date: Date;
  rangeDays: number;
}

/** The design's Home MarketsCard(6), trimmed to the short form, at full width. */
const COUNTRY_ROWS = 6;

const WatchlistMarketsRowComponent: React.FC<WatchlistMarketsRowProps> = ({ date, rangeDays }) => {
  const canFilterGeographically = useCanFilterGeographically();
  const topCountries = useTopCountries({
    date,
    rangeDays,
    limit: COUNTRY_ROWS,
    enabled: canFilterGeographically,
  });

  return (
    <Row className="mb-4 g-3">
      <Col xs={12}>
        <TopMarketsCard
          data={topCountries.data}
          isLoading={topCountries.isLoading}
          error={topCountries.error}
          retry={() => {
            topCountries.refetch().catch(console.error);
          }}
          canFilterGeographically={canFilterGeographically}
          rowLimit={COUNTRY_ROWS}
        />
      </Col>
    </Row>
  );
};

export const WatchlistMarketsRow = TypedMemo(WatchlistMarketsRowComponent);
